export const ALL_ITEM_TYPES = [
	'ARTICLE',
	'DOCUMENT',
	'PODCAST',
	'VIDEO',
	'WEB_PAGE',
] as const;
export type ItemType = (typeof ALL_ITEM_TYPES)[number];
export type ItemTypeMap<T> = Record<ItemType, T>;
export const FILTERABLE_TYPES: ItemType[] = ['ARTICLE', 'DOCUMENT', 'PODCAST'];
